import { Spacing } from '@treneo/shared/themes';
import { Box, Button, styled } from '@treneo/shared/ui';

export const FormContainer = styled(Box)`
  display: flex;
  flex-direction: column;
  gap: ${Spacing.medium};
  padding: ${Spacing.medium};
  max-width: 1100px;
  margin: 0 auto;
`;

export const CourseDateRow = styled(Box)`
  display: flex;
  gap: ${Spacing.medium};
  align-items: flex-start;
  flex-wrap: nowrap;

  @media (max-width: 768px) {
    gap: ${Spacing.small};
    flex-wrap: wrap;
  }
`;

export const DateTimePickerContainer = styled(Box)`
  display: flex;
  flex: 1;
  min-width: 0;
  flex-direction: column;
`;

export const ErrorMessageContainer = styled(Box)`
  min-height: 20px;
  margin-top: 3px;
  margin-left: 14px;
  margin-right: 14px;
`;

export const ActionButtonsContainer = styled(Box)`
  display: flex;
  align-items: center;
  gap: ${Spacing.small};
  flex-shrink: 0;
  height: 56px;
  padding-top: 0;

  @media (max-width: 768px) {
    width: 100%;
    justify-content: flex-start;
    height: auto;
    padding-top: ${Spacing.small};
  }
`;

export const CompactButton = styled(Button)`
  padding: 6px 8px;
  min-width: auto;

  .MuiButton-startIcon {
    margin-right: 4px;
    margin-left: 0;
  }
`;

export const ParticipantsRow = styled(Box)`
  display: flex;
  gap: ${Spacing.medium};
  align-items: center;
`;

export const ParticipantFieldContainer = styled(Box)`
  flex: 1;
`;

export const CheckboxSection = styled(Box)`
  display: flex;
  flex-direction: column;
  gap: 4px;
  border: 1px solid rgba(0, 0, 0, 0.23);
  border-radius: 4px;
  padding: ${Spacing.small};
`;
